import Vue from 'vue';
import App from '../app.vue';
import Router from './router';
import store from '../../store';

import '../common-settings';

export default {
  init(elementId) {
    const element = document.getElementById(elementId);

    if(element) {

      const router = new Router({
        base: element.getAttribute('data-base-url'),
      });

      new Vue({
        el: '#' + elementId,
        router,
        store,
        mounted () {
          // Stuff to do when mounted
        },
        render: createElement => {
          return createElement(App)
        },
        created: () => {

        }
      })
    }
  }
}
